import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]

import { computed, PropType } from "vue";
import { useI18n } from "vue-i18n";
import { UnitValue, UnitValueType } from "@/types/UnitValue";
import {
  calculateDurationSum,
  calculateQuantitySum,
  calculateUnitValueSum,
  calculateWorkforceSum,
  createFormatNumber,
} from "@/views/unitValues/unitValues";


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryCells',
  props: {
  unitValues: {
    type: Array as PropType<UnitValue[]>,
    required: true,
  },
  type: {
    type: String as PropType<UnitValueType>,
    required: true,
  },
  showLastRightBorder: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
},
  setup(__props) {

const formatNumber = createFormatNumber(useI18n().locale.value);

const props = __props;

const formattedSums = computed(() => ({
  duration: formatNumber(calculateDurationSum(props.unitValues, props.type)) ?? "",
  workforce: formatNumber(calculateWorkforceSum(props.unitValues, props.type)) ?? "",
  quantity: formatNumber(calculateQuantitySum(props.unitValues, props.type)) ?? "",
  value: formatNumber(calculateUnitValueSum(props.unitValues, props.type)) ?? "",
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "px-0.5 py-1 truncate text-md text-center border-r font-semibold",
      title: formattedSums.value.duration
    }, _toDisplayString(formattedSums.value.duration), 9, _hoisted_1),
    _createElementVNode("div", {
      class: "px-0.5 py-1 truncate text-md text-center border-r font-semibold",
      title: formattedSums.value.workforce
    }, _toDisplayString(formattedSums.value.workforce), 9, _hoisted_2),
    _createElementVNode("div", {
      class: "px-0.5 py-1 truncate text-md text-center border-r font-semibold",
      title: formattedSums.value.quantity
    }, _toDisplayString(formattedSums.value.quantity), 9, _hoisted_3),
    _createElementVNode("div", {
      class: _normalizeClass(["px-0.5 py-1 truncate text-md text-center bg-gray-100 font-semibold", {
      'border-r border-r-gray-600': __props.showLastRightBorder,
    }]),
      title: formattedSums.value.value
    }, _toDisplayString(formattedSums.value.value), 11, _hoisted_4)
  ], 64))
}
}

})